import styled, { CSSProperties } from 'styled-components';

export const ModalContainer = styled.div<{ styles: CSSProperties }>`
	${({ styles }) => ({
		...styles,
	})}
`;
